var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction"},[_c('div',{staticClass:"apparel"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"exchange"},[_c('h2',[_vm._v("Human-machine interactions"),_c('br'),_vm._v(" with smart wearables")]),_c('p',[_vm._v("Internet-of-every-mind embodied by BCI and AI")])])])])])
}]

export { render, staticRenderFns }